import { skipToken, useQuery } from "@tanstack/react-query";
import {
  getTransactionsPublicID,
  type TransactionDetailDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_DETAIL_QUERY_KEY = "TRANSACTIONS_DETAIL";

export const transactionsDetailKeys = {
  all: [TRANSACTIONS_DETAIL_QUERY_KEY],
  byPublicId: (publicID?: string | null) => [
    ...transactionsDetailKeys.all,
    publicID,
  ],
};

type Props = {
  publicID?: string | null;
  enabled?: boolean;
};

export const useTransactionsDetail = ({ publicID, enabled = true }: Props) =>
  useQuery<TransactionDetailDto>({
    queryKey: transactionsDetailKeys.byPublicId(publicID),
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getTransactionsPublicID(publicID),
        )
      : skipToken,
    enabled: !!publicID && enabled,
  });
